import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { Component } from "react";

import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      language: require("./English/LanguageSelector.json"),
      navbar: require("./English/Navbar/Navbar.json"),
      footer: require("./English/Footer/Footer.json"),
      privacy_policy: require("./English/PrivacyPolicy/PrivacyPolicy.json"),
      about: require("./English/AboutUs/AboutUs.json"),
      contact: require("./English/ContactUS/ContactUs.json"),
      user: require("./English/User/User.json"),
      home: require("./English/Home/Home.json"),
      component: require("./English/Component/Component.json"),
      api: require("./English/Api/Api.json"),
      wish: require("./English/Wishlist/Wishlist.json"),
      product: require("./English/Products/Products.json"),
      notification: require("./English/Notification/Notification.json"),
      order: require("./English/BuyerOrder/BuyerOrder.json"),
      global: require("./English/DashGlobal/Global.json"),
      categories: require("./English/DashCategory/Categories.json"),
      manage_user: require("./English/DashManageUser/ManageUser.json"),
      manage_order: require("./English/DashManageOrder/ManageOrder.json"),
      manage_product: require("./English/DashManageProduct/ManageProduct.json"),
      dashboard: require("./English/Dashboard/Dashboard.json"),
      manage_home: require("./English/DashManageHomePage/ManageHomePage.json"),
      payment: require("./English/DashPayments/Payments.json"),
      dash_contact: require("./English/DashContact/Contact.json"),
      faq: require("./English/FAQ/FAQ.json"),
      chat: require("./English/Chat/Chat.json"),
      post: require("./English/News/News.json"),
      ad: require("./English/DashAds/DashAds.json"),
      deliveryCost: require("./English/DeliveryCost/DeliveryCost.json"),
      logs: require("./English/Logs/Logs.json"),
      category: require("./English/Shop/Category.json"),
      shop: require("./English/Shop/Shop.json"),
      product: require("./English/Shop/Product.json"),
      supplier: require("./English/Shop/Supplier.json"),
      customer: require("./English/Shop/Customer.json"),
      purchase: require("./English/Shop/Purchase.json"),
      stock: require("./English/Shop/Stock.json"),
      unit: require("./English/Shop/Unit.json"),
      currency: require("./English/Shop/Currency.json"),
      sale: require("./English/Shop/Sale.json"),
      employee: require("./English/Shop/Employee.json"),
      payroll: require("./English/Shop/Payroll.json"),
      expense: require("./English/Shop/Expense.json"),
      expenseCategory: require("./English/Shop/ExpenseCategory.json"),
      purchasePayment: require("./English/Shop/PurchasePayment.json"),
      salePayment: require("./English/Shop/SalePayment.json"),
      sidebar: require("./English/Shop/Sidebar.json"),
      SaleReturnIndex: require("./English/Shop/saleReturn.json"),
      PurchaseReturnIndex: require("./English/Shop/purchaseReturn.json"),
      ReportIndex: require("./English/Shop/Reports.json"),
      reports: require("./English/Shop/Reports.json"),
      AdvanceIndex: require("./English/Shop/Advance.json"),
    },
  },
  dr: {
    translation: {
      language: require("./Dari/LanguageSelector.json"),
      navbar: require("./Dari/Navbar/Navbar.json"),
      footer: require("./Dari/Footer/Footer.json"),
      privacy_policy: require("./Dari/PrivacyPolicy/PrivacyPolicy.json"),
      about: require("./Dari/AboutUs/AboutUs.json"),
      contact: require("./Dari/ContactUS/ContactUs.json"),
      user: require("./Dari/User/User.json"),
      home: require("./Dari/Home/Home.json"),
      component: require("./Dari/Component/Component.json"),
      api: require("./Dari/Api/Api.json"),
      wish: require("./Dari/Wishlist/Wishlist.json"),
      product: require("./Dari/Products/Products.json"),
      notification: require("./Dari/Notification/Notification.json"),
      order: require("./Dari/BuyerOrder/BuyerOrder.json"),
      global: require("./Dari/DashGlobal/Global.json"),
      categories: require("./Dari/DashCategory/Categories.json"),
      manage_user: require("./Dari/DashManageUser/ManageUser.json"),
      manage_order: require("./Dari/DashManageOrder/ManageOrder.json"),
      manage_product: require("./Dari/DashManageProduct/ManageProduct.json"),
      dashboard: require("./Dari/Dashboard/Dashboard.json"),
      manage_home: require("./Dari/DashManageHomePage/ManageHomePage.json"),
      payment: require("./Dari/DashPayments/Payments.json"),
      dash_contact: require("./Dari/DashContact/Contact.json"),
      faq: require("./Dari/FAQ/FAQ.json"),
      chat: require("./Dari/Chat/Chat.json"),
      post: require("./Dari/News/News.json"),
      ad: require("./Dari/DashAds/DashAds.json"),
      deliveryCost: require("./Dari/DeliveryCost/DeliveryCost.json"),
      logs: require("./Dari/Logs/Logs.json"),
      category: require("./Dari/Shop/Category.json"),
      shop: require("./Dari/Shop/Shop.json"),
      product: require("./Dari/Shop/Product.json"),
      supplier: require("./Dari/Shop/Supplier.json"),
      customer: require("./Dari/Shop/Customer.json"),
      purchase: require("./Dari/Shop/Purchase.json"),
      stock: require("./Dari/Shop/Stock.json"),
      unit: require("./Dari/Shop/Unit.json"),
      currency: require("./Dari/Shop/Currency.json"),
      sale: require("./Dari/Shop/Sale.json"),
      employee: require("./Dari/Shop/Employee.json"),
      payroll: require("./Dari/Shop/Payroll.json"),
      expense: require("./Dari/Shop/Expense.json"),
      expenseCategory: require("./Dari/Shop/ExpenseCategory.json"),
      purchasePayment: require("./Dari/Shop/PurchasePayment.json"),
      salePayment: require("./Dari/Shop/SalePayment.json"),
      sidebar: require("./Dari/Shop/Sidebar.json"),
      SaleReturnIndex: require("./Dari/Shop/saleReturn.json"),
      PurchaseReturnIndex: require("./Dari/Shop/purchaseReturn.json"),
      ReportIndex: require("./Dari/Shop/Reports.json"),
      reports: require("./Dari/Shop/Reports.json"),
      AdvanceIndex: require("./Dari/Shop/Advance.json"),
    },
  },
  ps: {
    translation: {
      language: require("./Pashto/LanguageSelector.json"),
      navbar: require("./Pashto/Navbar/Navbar.json"),
      footer: require("./Pashto/Footer/Footer.json"),
      privacy_policy: require("./Pashto/PrivacyPolicy/PrivacyPolicy.json"),
      about: require("./Pashto/AboutUs/AboutUs.json"),
      contact: require("./Pashto/ContactUS/ContactUs.json"),
      user: require("./Pashto/User/User.json"),
      home: require("./Pashto//Home/Home.json"),
      component: require("./Pashto/Component/Component.json"),
      api: require("./Pashto/Api/Api.json"),
      wish: require("./Pashto/Wishlist/Wishlist.json"),
      product: require("./Pashto/Products/Products.json"),
      notification: require("./Pashto/Notification/Notification.json"),
      order: require("./Pashto/BuyerOrder/BuyerOrder.json"),
      global: require("./Pashto/DashGlobal/Global.json"),
      categories: require("./Pashto/DashCategory/Categories.json"),
      manage_user: require("./Pashto/DashManageUser/ManageUser.json"),
      manage_order: require("./Pashto/DashManageOrder/ManageOrder.json"),
      manage_product: require("./Pashto/DashManageProduct/ManageProduct.json"),
      dashboard: require("./Pashto/Dashboard/Dashboard.json"),
      manage_home: require("./Pashto/DashManageHomePage/ManageHomePage.json"),
      payment: require("./Pashto/DashPayments/Payments.json"),
      dash_contact: require("./Pashto/DashContact/Contact.json"),
      faq: require("./Pashto/FAQ/FAQ.json"),
      chat: require("./Pashto/Chat/Chat.json"),
      post: require("./Pashto/News/News.json"),
      ad: require("./Pashto/DashAds/DashAds.json"),
      deliveryCost: require("./Pashto/DeliveryCost/DeliveryCost.json"),
      logs: require("./Pashto/Logs/Logs.json"),
      category: require("./Pashto/Shop/Category.json"),
      shop: require("./Pashto/Shop/Shop.json"),
      product: require("./Pashto/Shop/Product.json"),
      supplier: require("./Pashto/Shop/Supplier.json"),
      customer: require("./Pashto/Shop/Customer.json"),
      purchase: require("./Pashto/Shop/Purchase.json"),
      stock: require("./Pashto/Shop/Stock.json"),
      unit: require("./Pashto/Shop/Unit.json"),
      currency: require("./Pashto/Shop/Currency.json"),
      sale: require("./Pashto/Shop/Sale.json"),
      employee: require("./Pashto/Shop/Employee.json"),
      payroll: require("./Pashto/Shop/Payroll.json"),
      expense: require("./Pashto/Shop/Expense.json"),
      expenseCategory: require("./Pashto/Shop/ExpenseCategory.json"),
      purchasePayment: require("./Pashto/Shop/PurchasePayment.json"),
      salePayment: require("./Pashto/Shop/SalePayment.json"),
      sidebar: require("./Pashto/Shop/Sidebar.json"),
      SaleReturnIndex: require("./Pashto/Shop/saleReturn.json"),
      PurchaseReturnIndex: require("./Pashto/Shop/purchaseReturn.json"),
      ReportIndex: require("./Pashto/Shop/Reports.json"),
      reports: require("./Pashto/Shop/Reports.json"),
      AdvanceIndex: require("./Pashto/Shop/Advance.json"),
    },
  },
};

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
